import React from 'react';
import Translate from '../shared/localization/localize';
import * as DT from '../../modules/datatable';
import * as Customers from '../../modules/customers';

export const getColumns = () => {
  const columnDefinitions: DT.TableColumn[] = [
    {
      Header: <Translate message={Customers.msgCustomerName} />,
      id: 'owner',
      accessor: 'owner',
      customizable: false,
      defaultShow: true,
    },
    {
      Header: <Translate message={Customers.msgNumDevices} />,
      id: 'numDevices',
      accessor: 'numDevices',
      customizable: true,
      defaultShow: true,
    },
  ];

  return DT.initColumnsVisibility(columnDefinitions);
};

export default getColumns;
